:host {
  display: block;
  container-type: inline-size;
  width: 100%;
}

:host(.container-query) ::slotted(*) {
  transition: all 0.3s ease;
}

/* :host(.container-query) ::slotted(*) {} */